import { IDocument } from 'entities/user/module'

import { TypesGenderList } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { showWrongDateFormat } from 'shared/lib/dateFormat'

export const renderProfileInfo = (accountData: IDocument | undefined) => {
  const listData = [
    {
      id: 'last_name',
      title: 'last_name',
      content: accountData?.last_name,
    },
    {
      id: 'first_name',
      title: 'first_name',
      content: accountData?.first_name,
    },
    {
      id: 'gender',
      title: 'gender',
      content: TypesGenderList?.find(
        (gender) => gender.name === accountData?.gender,
      )?.name,
    },
    {
      id: 'birth_day',
      title: 'birth_day',
      content:
        showWrongDateFormat(
          accountData?.date_of_birth || '',
          DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
        ) || '',
    },
    {
      id: 'citizenship',
      title: 'citizenship',
      content: (accountData?.citizenship_obj?.country || '').toUpperCase(),
    },
    {
      id: 'serial_documents',
      title: 'serial_documents',
      content: String(accountData?.document_number || ''),
    },
    {
      id: 'expiration_date',
      title: 'expiration_date',
      content: showWrongDateFormat(
        accountData?.document_expire || '',
        DATE_FORMAT_LIST.FULL_DATE_WITH_MONTH_STAND_ALONE,
      ),
    },
    // {
    //   id: 'middle_name',
    //   title: 'middle_name',
    //   content: accountData?.middle_name,
    // },
  ]

  if (accountData?.middle_name) {
    listData.splice(4, 0, {
      id: 'middle_name',
      title: 'middle_name',
      content: accountData?.middle_name,
    })
  }

  return listData
}
